import { createSelector } from 'reselect';
import { getOffline } from './getOffline';
import { getIsAgentConnected } from './getIsAgentConnected';
import { getUnavailableStartAt } from './getUnavailableStartAt';
import { getFaultStartAt } from './getFaultStartAt';
import { getStatusLabel } from './getStatusLabel';

export const getMachineHeaderState = createSelector(
  [
    getOffline,
    getIsAgentConnected,
    getUnavailableStartAt,
    getFaultStartAt,
    getStatusLabel,
  ],
  (offline, isAgentConnected, unavailableStartAt, faultStartAt, status) => {
    const fault = !!faultStartAt;
    if (offline) {
      return 'no internet connection';
    }
    if (!isAgentConnected && unavailableStartAt) {
      return 'edge device connection error';
    }
    if (fault) {
      return 'in fault';
    }
    return status;
  }
);
